export default function Tag({ children, className, size, backgroundColor, color }) {
    return <span className={`tag ${className !== undefined ? className : ''} ${size != undefined ? size : ''}`} style={{ backgroundColor, color, border: `1px solid ${backgroundColor}` }}>{children}</span>;
}